//@flow
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { FlexRow, Spacer } from 'styles/Layout';
import ButtonDropDown from 'components/shared/ButtonDropDownComponent';
import { media } from 'styles/Mixins';
import HomieContext from 'HomieContext';
import AuthenticationAction from 'actions/AuthenticationAction';
import swal from '@sweetalert/with-react';
import { HeaderIcons } from 'utils/ExportCommon';

const Wrapper = styled(FlexRow)`
  position: sticky;
  top: 0;
  width: 100%;
  height: 85px;
  background-color: #f9f9f9;
  z-index: 1;
`;

const Container = styled(FlexRow)`
  padding: 0 15px;
  ${media.md`
    width: 100%;
    padding: 0 30px;
    margin: auto;
  `}
`;

const ImageContainer = styled(FlexRow)`
  margin-right: 27px;
`;
const Logo = styled(HeaderIcons.LogoSVG)`
  height: 43px;
  width: 88px;
`;

const LeftTitle = styled.h1`
  height: 44px;
	width: 106px;
	color: #4F5EA3;
	font-size: 18px;
	font-weight: bold;
	line-height: 22px;
}
`;

const Arrow = styled(HeaderIcons.DownArrow)`
  height: 10px;
  width: 16px;
  margin-right: 20px;
`;

const ProfileImageLogin = styled(FlexRow)`
  display: flex;
  align-items: center;
`;

const Option = styled(FlexRow)`
  min-height: 60px;
  min-width: 0;
  transition: background-color 0.2s linear;
  cursor: pointer;
  &:hover {
    background-color: #eee;
  }
  display: ${props => (props.hideInMobile ? 'none' : 'flex')};
  ${media.md`
    min-width: 120px;
    display: ${props => (props.hideInDesktop ? 'none' : 'flex')};
  `};
`;

const LoginDropDownOption = styled(Option)`
  min-height: 35px;
  width: 100%;
  min-width: 100% !important;
  align-items: center;
  font-size: 14px;
  padding: 9px 15px;
  color: #4a4a4a;
  font-size: 14px;
  line-height: 17px;
  user-select: none;
`;

const ProfileImage = styled.div.attrs({
  style: ({ url }) => ({
    backgroundImage: `url('${url}')`
  })
})`
  display: block;
  height: 30px;
  width: 30px;
  background: 50% no-repeat;
  background-size: cover;
  border-radius: 50%;
  z-index: 4;
  pointer-events: none;
`;

const FullName = styled.p`
  margin-bottom: 0px;
  margin-left: 3px;
  width: 66px;
  color: #4a4a4a;
  font-family: 'Product Sans';
  font-size: 14px;
  font-weight: bold;
  line-height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DropDownLoginContainer = ({ onLogout }: any) => {
  return (
    <LoginDropDownOption onClick={onLogout}>Cerrar sesión</LoginDropDownOption>
  );
};

const DropDownLoginButton = ({ avatar, fullName }: any) => {
  return (
    <ProfileImageLogin>
      <ProfileImage url={avatar || ''} />
      <FullName>{fullName}</FullName>
      <Arrow />
    </ProfileImageLogin>
  );
};

type PropsType = {
  urlToRedirect: string,
  pathImageLogo: string,
  location: any,
  history: any
};

class Header extends PureComponent<PropsType> {
  static defaultProps = {
    isSearchVisible: true
  };

  onLogout = () => {
    AuthenticationAction.logout(response => {
      if (response && response.csrf) {
        this.props.history.push('/');
        swal({
          className: 'logout',
          icon: '',
          title: 'Has salido del sistema',
          timer: 5000,
          button: {
            text: 'OK',
            value: true,
            visible: true,
            closeModal: true
          }
        });
      } else {
        location.reload();
      }
    });
  };

  render() {
    return (
      <Wrapper alignItems="center">
        <Container alignItems="center">
          <LeftTitle>Dashboard Permisos</LeftTitle>
          <Spacer />
          <ButtonDropDown
            isOpenDropDown={false}
            BodyContainer={() => {
              return (
                <DropDownLoginContainer
                  onLogout={this.onLogout}
                  onClick={() => {}}
                />
              );
            }}
            ButtonContainer={() => {
              return (
                <DropDownLoginButton
                  avatar={this.context.currentUser.avatar}
                  fullName={this.context.currentUser.fullName}
                />
              );
            }}
            alignment={'right'}
            visible={true}
          />
          <ImageContainer justifyContent="center">
            <Logo />
          </ImageContainer>
        </Container>
      </Wrapper>
    );
  }
}

export default withRouter(Header);
Header.contextType = HomieContext;
